module.exports = {
  SIGN_IN: 'Sign in',
  SIGN_UP: 'Sign up',
  UNDER_DEVELOPMENT: 'Under Development',
  HOME: 'Home',
  DASHBOARD: 'Dashboard',
  WORKFLOW: 'Workflow',
  DOCUMENTS: 'Documents',
  ACCOUNT: 'Account',
  DESIGN: 'Design',
  DEMO: 'Demo',
  SETTINGS: 'Settings',
  LEEGALITY_DASHBOARD: 'Leegality Dashboard',
  MY_ACCOUNT: 'My Account',
  MY_SIGNATURES: 'My Signatures',
  PROVISIONS: 'Provisions',
  PROFILE: 'Profile',
  SIGNATURES: 'Signatures',
  ID: 'Id',
  GENDER: 'Gender',
  COMMUNICATION_ADDRESS: 'Communication Address',
  BILLING_ADDRESS: 'Billing Address',
  PLAN: 'Plan',
  TEAM: 'Team',
  BALANCE: 'Balance',
  LANGUAGES: 'Languages',
  HINDI: 'Hindi',
  ENGLISH: 'English',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  CONFIRM: 'Confirm',
  DISCARD: 'Discard',
  SAVE_CHANGES: 'Save changes',
  LEARN_MORE: 'Learn more',
  DISMISS: 'Dismiss',
  SELECT_DATE: 'Select date',
  DTP_LAST_7_DAYS: 'Last 7 Days',
  DTP_LAST_30_DAYS: 'Last 30 Days',
  DTP_THIS_MONTH: 'This Month',
  DTP_LAST_MONTH: 'Last Month',
  DTP_TODAY: 'Today',
  THIS: 'This',
  DTP_YESTERDAY: 'Yesterday',
  DTP_CANCEL: 'Cancel',
  DTP_APPLY: 'Apply',
  DTP_FROM: 'From',
  DTP_TO: 'To',
  DTP_CUSTOM: 'Custom',
  DTP_ALL_TIME: 'All Time',
  LEEGALITY_COPYRIGHTS: 'Copyright © 2022 Leegality',
  WELCOME_BACK: 'Welcome back',
  SIGN_IN_TO_LEEGALITY: 'Sign in to Leegality',
  WELCOME_BACK_LOGIN_HELPER: 'Welcome back! Please enter your details.',
  SIGN_IN_WITH_OTP_HELPER: 'Didn\'t set password or forgot your password? You can always sign in with OTP.',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  FORGOT_PASSWORD: 'Forgot password',
  SIGN_IN_WITH_OTP: 'Sign in with OTP',
  SIGN_IN_WITH_PASSWORD: 'Sign in with password',
  SEND_OTP: 'Send OTP',
  ENTER_YOUR_EMAIL_MOBILE: 'Enter your email or mobile',
  DIDNT_RECEIVE_EMAIL: 'Didn\'t receive the email?',
  RESEND_OTP_IN: 'Resend OTP in',
  RESEND_OTP: 'Resend OTP',
  AND: 'and',
  TERMS_OF_SERVICE: 'Terms of Service',
  PRIVACY_POLICY: 'Privacy Policy',
  NAME: 'Name',
  ENTER_YOUR_NAME: 'Enter your name',
  ACCESS_DENIED: 'Access Denied',
  GO_BACK: 'Go Back',
  MSG_WELCOME: 'Welcome to the Leegality Frontend',
  MSG_LANDING_PAGE: 'This is the landing page of the web-app. It maps to the "/" (root) path.',
  MSG_GO_TO_SIGN_IN: 'Go to Sign-in',
  MSG_GO_TO_SIGN_UP: 'Go to Sign-up',
  MSG_GO_TO_DASHBOARD: 'Go to Dashboard',
  MSG_UNDER_CONSTRUCTION: 'We are brewing something awesome for you. \nStay tuned!',
  MSG_SIGN_IN_PAGE: 'This is the sign-in page',
  MSG_CLICK_TO_GO_TO_DASHBOARD: 'Click the button to go to the Dashboard.',
  MSG_VAL_TEXT_NOT_EMPTY: '{label} is a required field',
  MSG_VAL_TEXT_NOT_EMPTY_NO_SPACE: '{label} is a required field and cannot contain empty spaces',
  MSG_VAL_TEXT_MIN_CHAR_COUNT: 'Should be minimum {text_min_char_count} characters',
  MSG_VAL_TEXT_MAX_CHAR_COUNT: 'Should be maximum {text_max_char_count} characters',
  MSG_VAL_TEXT_NUMBER: 'Please enter a valid number',
  MSG_VAL_TEXT: 'Only alphabets allowed',
  MSG_VAL_TEXT_MATCH: '{name} does not match.',
  MSG_VAL_MIN_ONE_DIGIT: '{label} should have minimum one digit',
  MSG_VAL_NO_CONSECUTIVE_NUMBERS: '{label} should not have consecutive numbers',
  MSG_VAL_ONE_LOWER_CHAR_CASE: '{label} should have a lowercase character',
  MSG_VAL_ONE_UPPER_CHAR_CASE: '{label} should have a uppercase character',
  MSG_VAL_TEXT_MIN_SPECIAL_CHAR_COUNT: '{label} should have a special character',
  MSG_VAL_ALL_CHARS_WITH_DOT_AND_SPACE: 'Only characters a-z, A-Z, space & dot allowed.',
  MSG_VAL_TEXT_ALL_NO_NUMBER: 'Please remove numbers from the text',
  MSG_VAL_TEXT_EMAIL: 'Please enter a valid email address',
  MSG_VAL_TEXT_URL: 'Please enter valid URL and Allowed input includes alphanumeric characters and - _ . ~ : / ? # [ ] @ ! $ & \' ( ) * + , ; = %',
  MSG_VAL_IPV4: 'Please enter a valid IPv4 address.',
  MSG_ALPHA_NUM_WITH_PUNC_CHAR: 'Please remove special characters',
  MSG_ASCII_CHAR: 'Please remove special characters',
  MSG_ASCII_CHAR_WITH_RESTRICTION: 'Allowed input includes alphanumeric characters and | - : () , _ . [] & / # + @ ; \' –',
  MSG_SIGN_IN_TNC: 'By proceeding, you agree to the',
  MSG_ACCESS_DENIED: 'Sorry, you do not have permission to access this page. \nPlease contact your administrator.',
  OR_DRAG_AND_DROP: 'or drag and drop',
  CLICK_TO_UPLOAD_LABEL: 'Click to Upload',
  CLEAR_SELECTION: 'Clear Selection',
  SEARCH: 'Search',
  UPLOAD_FAILED_MESSAGE: 'Upload failed, Please try again',
  CLEAR_ALL: 'Clear All',
  FILTER_BY: 'Filter By',
  SELECTED_LOWER: 'selected',
  TABLE_PAGINATION_BRIEF: '{range} of {total} records',
  NOTHING_SELECTED: 'Nothing Selected',
  COLUMNS: 'Columns',
  ALL: 'All',
  CLICK_UNSTAR: 'Click to Un-Star',
  CLICK_STAR: 'Click to Star',
  CLICK_TO_REUPLOAD_LABEL: 'Click to re-upload',
  SCROLL_TO_RIGHT: 'Scroll to Right',
  SCROLL_TO_LEFT: 'Scroll to Left',
  CONFIGURE_COLUMNS: 'Configure Columns',
  MSG_SELECT_ITEMS_LIMIT: 'Only {number} items can be chosen at a time.',
  DUPLICATE_ITEM_FOUND: 'Duplicate item found',
  USE_COMMAS_TO_SEPARATE_ITEMS: 'Use commas to add and separate items',
  DAYS_AGO: 'days ago',
  LEFT: 'left',
  LAST_X_DAYS: 'Last {x} days',
  NEXT_X_DAYS: 'Next {x} days',
  DAYS_LEFT: 'days left',
  NO_RESULT_FOUND: 'No Results Found',
  NO_RESULTS_FOUND: 'No results found',
  TRY_ADJUSTING_SEARCH_FILTER: 'Try adjusting your search or filter to find what you’re looking for.',
  DATE: 'Date',
  MAX_ALLOWED_FILE_SIZE: 'Maximum allowed file size is {size}',
  VIEW_MORE: 'View More',
  VIEW_LESS: 'View Less',
  UPLOAD_FILES_HERE: 'Upload file/s here',
  UPLOAD: 'Upload',
  FILE_NAME: 'File Name',
  ENTER_FILE_NAME: 'Enter File Name',
  SAVE: 'Save',
};
